<template>
  <f7-page name="ccm-homework-study" class="page-bg-render">
    <f7-navbar>
			<f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <div class="title">
        숙제 목록
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <f7-block-title>해야할 숙제 목록</f7-block-title>
		<div class="list">
			<ul>
				<template v-for="(item, i) in homeWorkList">
					<li :key="'ii' + i">
						<a href="#" class="item-link" v-on:click="homeWorkClick(item);">
							<div class="item-content item-inner">
								<div class="item-title">
									<div class="item-header">{{studyTypeDisplay(item.STUDY_TYPE)}} : {{item.STUDY_CODE}}</div>
									{{item.STUDY_NAME}} ({{item.TOTAL_ITEM_CNT}}문제)
								</div>
								<div class="item-after"><span class="badge color-orange">숙제하기</span></div>
							</div>
						</a>
					</li>		
				</template>			
			</ul>
		</div>

		<f7-block-title>완료한 숙제 목록</f7-block-title>
		<div class="list">
			<ul>
				<template v-for="(item, i) in homeWorkResultList">
					<li :key="'ii' + i">
						<a href="#" class="item-link" v-on:click="homeWorkResultClick(item);">
							<div class="item-content item-inner">
								<div class="item-title">
									<div class="item-header">{{studyTypeDisplay(item.STUDY_TYPE)}} : {{item.STUDY_CODE}}</div>
									{{item.STUDY_NAME}} ({{item.TOTAL_ITEM_CNT}}문제)
								</div>
								<div class="item-after"><span class="badge color-gray">결과보기</span></div>
							</div>
						</a>
					</li>		
				</template>			
			</ul>
		</div>   
  </f7-page>
</template>

<script>
import { f7 } from 'framework7-vue';
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import PAGES from '../../../js/pages';
import AUTH from '../../../js/common/auth.js';
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';

export default {
  data() {
    return {
      code: "",
			homeWorkList: [],
			homeWorkResultList: []
    }
  },
  mounted() {
		const _this = this;
		
		_this.onPageShow();	
  },
  methods: {
    onPageShow(e) {
			const _this = this;			
			_this.loadHomeworkList();
		},
		homeWorkClick(item) {
			const _this = this;		

			if(MODULE.Util.isEmpty(item.STUDY_CODE) || 
				MODULE.Util.isEmpty(item.STUDY_KEY)) {

				MODULE.DialogBox.message("에러", "학습에 필요한 데이타가 없습니다.");
				return;
			}

			var perfix = MODULE.Util.codePrefix(item.STUDY_CODE);
			var url = "";
			var param = undefined;

			if(perfix == CONST.examSetCodePrefix) {
				url = PAGES.SUB_CCM_EXAMSET_APPLY;
			}else if(perfix == CONST.matchBookCodePrefix) {
				url = PAGES.SUB_CCM_MATCHBOOK_APPLY;				
			}else if(perfix == CONST.matchPaperCodePrefix) {
				url = PAGES.SUB_CCM_MATCHPAPER_APPLY;
			}else {
				MODULE.DialogBox.message("에러", "잘못된 코드입니다.<br/>코드를 확인하세요.");
        return;
			}		
				  
			param = {
				studyType: item.STUDY_TYPE, 
				code: item.STUDY_CODE,                  
				studyKey: item.STUDY_KEY,
				startPageNo: item.SUB_P1,
				endPageNo: item.SUB_P2,
				startExamNo: item.SUB_E1,
				endExamNo: item.SUB_E2
			}

			PAGES.popPage(url, param);
	
		},
		homeWorkResultClick(item) {
			const _this = this;

			if (MODULE.Util.isEmpty(item.RESULT_KEY)) {
				MODULE.DialogBox.message("에러","학습결과에 필요한 데이타가 없습니다.");
				return;
			}
			
			var perfix = MODULE.Util.codePrefix(item.STUDY_CODE);
			var url = "";
			var param = {};

			if(perfix == CONST.examSetCodePrefix) {
				url = PAGES.SUB_CCM_EXAMSET_APPLY;
			}else if(perfix == CONST.matchBookCodePrefix) {
				url = PAGES.SUB_CCM_MATCHBOOK_APPLY;
			}else if(perfix == CONST.matchPaperCodePrefix) {
				url = PAGES.SUB_CCM_MATCHPAPER_APPLY;
			}else {
				MODULE.DialogBox.message("에러", "잘못된 코드입니다.<br/>코드를 확인하세요.");
        return;
			}
		
			param = {
				studyType: item.STUDY_TYPE, 
				studyResultKey: item.RESULT_KEY,
				code: item.STUDY_CODE,                  
				studyKey: item.STUDY_KEY,
				startPageNo: item.SUB_P1,
				endPageNo: item.SUB_P2,
				startExamNo: item.SUB_E1,
				endExamNo: item.SUB_E2
			};
		
			PAGES.popPage(url, param);
		},
		studyTypeDisplay(studyType) {
			
			return CONST.studyType[studyType].shortName;
		},
    loadHomeworkList() {
			const _this = this;

			let param ={}

			API.ajaxRequest({
				url: API.getMyHomeWorkListUrl(),
				data: param
			}).then(function(data) {
				
				if(data.homeWorkList.length > 0) {					
					for(var i=0; i < data.homeWorkList.length; i++) {
						var homeWorkItem = data.homeWorkList[i];
						_this.homeWorkList.push(homeWorkItem);
					}
				}

				if(data.homeWorkResultList.length > 0) {					
					for(var i=0; i < data.homeWorkResultList.length;  i++) {
						var homeWorkResultItem = data.homeWorkResultList[i];
						_this.homeWorkResultList.push(homeWorkResultItem);
					}
				}

			}).catch(function(code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
			
    }
  }
}

</script>